// TradingViewWidget.jsx
import React, { useEffect, useRef, memo } from 'react';

function TradingViewWidget() {
  const container = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    const el = container.current;
    if (!el || initialized.current) return;

    // Prefer user's color scheme for better visual integration
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    const locale = (typeof document !== 'undefined' && document.documentElement?.lang) || 'en';
    const isMobile = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(max-width: 600px)').matches
      : false;

    const symbolsDesktop = [
      { proName: 'FOREXCOM:SPXUSD', title: 'S&P 500 Index' },
      { proName: 'FOREXCOM:NSXUSD', title: 'US 100 Cash CFD' },
      { proName: 'FX_IDC:EURUSD', title: 'EUR/USD' },
      { proName: 'BITSTAMP:BTCUSD', title: 'BTC/USD' },
      { proName: 'BITSTAMP:ETHUSD', title: 'ETH/USD' },
    ];
    const symbolsMobile = [
      { proName: 'FOREXCOM:SPXUSD', title: 'S&P 500' },
      { proName: 'FOREXCOM:NSXUSD', title: 'US 100' },
      { proName: 'FX_IDC:EURUSD', title: 'EURUSD' },
      { proName: 'BITSTAMP:BTCUSD', title: 'BTCUSD' },
      { proName: 'BITSTAMP:ETHUSD', title: 'ETHUSD' },
    ];

    const config = {
      symbols: isMobile ? symbolsMobile : symbolsDesktop,
      colorTheme: prefersDark ? 'dark' : 'light',
      locale,
      largeChartUrl: '',
      isTransparent: true,
      showSymbolLogo: !isMobile,
      // Prefer single-line per item on mobile
      displayMode: isMobile ? 'regular' : 'adaptive',
    };

    try {
      // Avoid duplicates (React 18 StrictMode double-effect in dev)
      el.innerHTML = '';
      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
      script.type = 'text/javascript';
      script.async = true;
      script.textContent = JSON.stringify(config);
      el.appendChild(script);
      initialized.current = true;
    } catch {
      // ignore
    }

    return () => {
      // Cleanup on unmount
      try { if (el) el.innerHTML = ''; } catch { /* ignore */ }
      initialized.current = false;
    };
  }, []);

  return (
    <div
      className="tradingview-widget-container"
      ref={container}
      aria-label="Market ticker tape"
    >
      <div className="tradingview-widget-container__widget" />
    </div>
  );
}

export default memo(TradingViewWidget);
